/*
    * Type Scripts Methods And Events
*/
import Vue from "vue";
import { About } from "../../../../store/modules/App/Assets/About/types";
import { Component } from "vue-property-decorator";
import { State, Action } from "vuex-class";
import { App } from "../../../../store/modules/App/types";

const namespace: string = "RootAbout";

/*
    * Component's properties and events
*/
@Component({
    components: {
    }
})

export default class AppsComponent extends Vue {
    @State("RootAbout") about!: About;
    @State("RootApp") app!: App;
    @Action("_aboutDialogClose", { namespace }) _aboutDialogClose: any;

    appInfo:any = {};

    /*
        * The mounted() method gives you access to templates and enables interaction with the DOM.
    */
    mounted() {
        this.about.dialog = true;

        this.$services.dashboard.getAppInfo()
            .then((data) => {
                this.appInfo = data;
            });
    }

    get userAgent() {
        return navigator.userAgent
    }

    get resolution() {
        return `${window.screen.availWidth} x ${window.screen.availHeight}`
    }
}